import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';

export const Home = () => {
  const services = [
    {
      icon: 'fa-user-clock',
      title: 'Aposentadoria por Idade',
      description:
        'Assessoria completa para solicitação de aposentadoria por idade, garantindo todos os benefícios que você tem direito.',
    },
    {
      icon: 'fa-shield-alt',
      title: 'Aposentadoria Especial',
      description:
        'Especialistas em reconhecimento de atividades especiais e insalubres para garantir sua aposentadoria diferenciada.',
    },
    {
      icon: 'fa-hands-helping',
      title: 'BPC/LOAS',
      description:
        'Benefício assistencial para idosos e pessoas com deficiência. Acompanhamento completo do processo.',
    },
    {
      icon: 'fa-sync-alt',
      title: 'Revisões e Reajustes',
      description:
        'Análise detalhada do seu benefício para identificar possibilidades de revisão e aumento de valores.',
    },
  ];

  const testimonials = [
    {
      name: 'Ana Silva',
      role: 'Aposentada',
      comment:
        'A consultoria da Godoy Melo foi incrivelmente útil. Eles me guiaram em todo o processo e me ajudaram a receber os benefícios que eu nem sabia que tinha direito. Altamente recomendado!',
      rating: 5,
    },
    {
      name: 'Ricardo Santos',
      role: 'Servidor Público',
      comment:
        'Estou muito grato pelos serviços prestados pela equipe. Eles foram atenciosos, profissionais e eficientes. Não poderia ter feito isso sem a ajuda deles.',
      rating: 5,
    },
    {
      name: 'Carla Oliveira',
      role: 'Empresária',
      comment:
        'Recomendo a Godoy Melo a todos que precisam de orientação e suporte com benefícios previdenciários. Excelente equipe e serviço excepcional.',
      rating: 5,
    },
  ];

  const stats = [
    { value: '500+', label: 'Casos Resolvidos' },
    { value: '7+', label: 'Anos de Experiência' },
    { value: '98%', label: 'Taxa de Aprovação' },
    { value: '24/7', label: 'Suporte Disponível' },
  ];

  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section
        className="relative min-h-[600px] lg:min-h-[700px] flex items-center justify-center bg-cover bg-center"
        style={{
          backgroundImage:
            'linear-gradient(135deg, rgba(45, 66, 56, 0.95) 0%, rgba(45, 66, 56, 0.85) 100%), url(https://images.unsplash.com/photo-1589829545856-d10d557cf95f?q=80&w=2070)',
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-primary/20"></div>
        <div className="container-padding mx-auto relative z-10">
          <div className="max-w-4xl mx-auto text-center space-y-8 slide-up">
            <div className="inline-block">
              <span className="inline-block px-4 py-2 bg-accent/20 backdrop-blur-sm border border-accent/30 rounded-full text-accent-foreground text-sm font-semibold mb-4">
                Seu direito previdenciário em boas mãos
              </span>
            </div>
            <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold text-primary-foreground leading-tight">
              Planejamos o Seu Futuro com{' '}
              <span className="text-accent">Excelência</span>
            </h1>
            <p className="text-lg sm:text-xl text-primary-foreground/90 max-w-2xl mx-auto leading-relaxed">
              Especialistas em direito previdenciário comprometidos em garantir seus benefícios
              e aposentadoria com segurança e tranquilidade.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center pt-4">
              <Button
                asChild
                size="lg"
                className="bg-accent hover:bg-accent-hover text-accent-foreground font-semibold px-8 shadow-xl hover:shadow-2xl transition-all hover:scale-105"
              >
                <Link to="/contato">
                  <i className="fas fa-phone-alt mr-2"></i>
                  Fale no WhatsApp
                </Link>
              </Button>
              <Button
                asChild
                size="lg"
                variant="outline"
                className="border-2 border-primary-foreground/20 text-primary-foreground hover:bg-primary-foreground/10 backdrop-blur-sm font-semibold px-8"
              >
                <Link to="/calculadora">
                  <i className="fas fa-calculator mr-2"></i>
                  Calcule sua Aposentadoria
                </Link>
              </Button>
            </div>
          </div>
        </div>
        {/* Scroll Indicator */}
        <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
          <i className="fas fa-chevron-down text-primary-foreground/60 text-2xl"></i>
        </div>
      </section>

      {/* Stats Section */}
      <section className="bg-secondary py-12">
        <div className="container-padding mx-auto">
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
            {stats.map((stat, index) => (
              <div key={index} className="text-center slide-up" style={{ animationDelay: `${index * 0.1}s` }}>
                <div className="font-display text-4xl lg:text-5xl font-bold text-primary mb-2">
                  {stat.value}
                </div>
                <div className="text-muted-foreground font-medium">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="section-padding bg-background">
        <div className="container-padding mx-auto">
          <div className="text-center max-w-3xl mx-auto mb-12 lg:mb-16 slide-up">
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold text-primary mb-4">
              Como Podemos te Ajudar?
            </h2>
            <p className="text-lg text-muted-foreground">
              Oferecemos assessoria completa em direito previdenciário com atendimento
              personalizado e eficiente.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8">
            {services.map((service, index) => (
              <Card
                key={index}
                className="card-hover border-border hover:border-accent/50 transition-all cursor-pointer group"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <CardContent className="p-6 space-y-4 flex flex-col h-full">
                  <div className="w-14 h-14 bg-accent-light rounded-lg flex items-center justify-center group-hover:scale-110 transition-transform">
                    <i className={`fas ${service.icon} text-2xl text-accent`}></i>
                  </div>
                  <h3 className="font-display text-xl font-semibold text-foreground group-hover:text-accent transition-colors">
                    {service.title}
                  </h3>
                  <p className="text-muted-foreground text-sm leading-relaxed flex-grow">
                    {service.description}
                  </p>
                  <div className="mt-auto pt-4">
                    <Link
                      to="/servicos"
                      className="text-accent hover:text-accent-hover font-semibold text-sm inline-flex items-center group"
                    >
                      Saiba mais
                      <i className="fas fa-arrow-right ml-2 group-hover:translate-x-1 transition-transform"></i>
                    </Link>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>

          <div className="text-center mt-12">
            <Button
              asChild
              size="lg"
              variant="outline"
              className="border-2 border-primary text-primary hover:bg-primary hover:text-primary-foreground font-semibold px-8"
            >
              <Link to="/servicos">
                Ver Todos os Serviços
                <i className="fas fa-arrow-right ml-2"></i>
              </Link>
            </Button>
          </div>
        </div>
      </section>

      {/* Why Choose Us Section */}
      <section className="section-padding bg-primary text-primary-foreground">
        <div className="container-padding mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
            <div className="space-y-6 slide-in-left">
              <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold">
                Por que Escolher a Godoy Melo?
              </h2>
              <p className="text-lg text-primary-foreground/90 leading-relaxed">
                A Godoy & Aguiar é uma Sociedade de Advogados dedicada a orientar você em questões de Previdência, Direito do Trabalho e Tributário. Nossa equipe atua de forma próxima e personalizada, sempre buscando a melhor posição possível dentro da lei, para que você tenha mais segurança e tranquilidade no seu dia a dia e no futuro.
              </p>

              <div className="space-y-4">
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-accent rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="fas fa-bullseye text-accent-foreground text-xl"></i>
                  </div>
                  <div>
                    <h4 className="font-display text-xl font-semibold mb-2">Missão</h4>
                    <p className="text-primary-foreground/80 text-sm leading-relaxed">
                      Garantir justiça e segurança para nossos clientes.
                    </p>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-accent rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="fas fa-heart text-accent-foreground text-xl"></i>
                  </div>
                  <div>
                    <h4 className="font-display text-xl font-semibold mb-2">Valores</h4>
                    <p className="text-primary-foreground/80 text-sm leading-relaxed">
                      Ética, compromisso e excelência em cada caso.
                    </p>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-accent rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="fas fa-eye text-accent-foreground text-xl"></i>
                  </div>
                  <div>
                    <h4 className="font-display text-xl font-semibold mb-2">Visão</h4>
                    <p className="text-primary-foreground/80 text-sm leading-relaxed">
                      Ser referência em direito previdenciário no país.
                    </p>
                  </div>
                </div>
              </div>

              <Button
                asChild
                size="lg"
                className="bg-accent hover:bg-accent-hover text-accent-foreground font-semibold px-8 shadow-xl mt-6"
              >
                <Link to="/sobre-nos">
                  Conheça Nossa Equipe
                  <i className="fas fa-arrow-right ml-2"></i>
                </Link>
              </Button>
            </div>

            <div className="relative slide-in-right rounded-lg shadow-2xl bg-muted overflow-hidden">
              <img
                src="/team-photo.jpg"
                alt="Equipe de advogados Godoy & Aguiar"
                className="w-full h-auto object-contain"
              />
              <div className="absolute bottom-6 left-6 bg-accent text-accent-foreground p-4 sm:p-6 shadow-xl" style={{ borderRadius: '7px' }}>
                <div className="font-display text-2xl sm:text-3xl font-bold">7+</div>
                <div className="text-xs sm:text-sm font-semibold">Anos de Experiência</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="section-padding bg-secondary">
        <div className="container-padding mx-auto">
          <div className="text-center max-w-3xl mx-auto mb-12 lg:mb-16 slide-up">
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold text-primary mb-4">
              Depoimentos
            </h2>
            <p className="text-lg text-muted-foreground">
              Veja o que nossos clientes dizem sobre nosso trabalho
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
            {testimonials.map((testimonial, index) => (
              <Card
                key={index}
                className="card-hover border-border"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <CardContent className="p-6 space-y-4">
                  <div className="flex space-x-1">
                    {[...Array(testimonial.rating)].map((_, i) => (
                      <i key={i} className="fas fa-star text-accent"></i>
                    ))}
                  </div>
                  <p className="text-muted-foreground italic leading-relaxed">
                    &ldquo;{testimonial.comment}&rdquo;
                  </p>
                  <div className="pt-4 border-t border-border">
                    <div className="font-semibold text-foreground">{testimonial.name}</div>
                    <div className="text-sm text-muted-foreground">{testimonial.role}</div>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="section-padding bg-gradient-to-r from-primary to-primary-dark text-primary-foreground">
        <div className="container-padding mx-auto">
          <div className="max-w-4xl mx-auto text-center space-y-6 slide-up">
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold">
              Pronto para Garantir Seus Direitos?
            </h2>
            <p className="text-lg sm:text-xl text-primary-foreground/90">
              Entre em contato conosco e fale com um especialista. Estamos prontos para ajudá-lo.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center pt-4">
              <Button
                asChild
                size="lg"
                className="bg-accent hover:bg-accent-hover text-accent-foreground font-semibold px-8 shadow-xl hover:shadow-2xl transition-all hover:scale-105"
              >
                <Link to="/contato">
                  <i className="fas fa-phone-alt mr-2"></i>
                  Fale Conosco
                </Link>
              </Button>
              <Button
                asChild
                size="lg"
                variant="outline"
                className="border-2 border-primary-foreground/20 text-primary-foreground hover:bg-primary-foreground/10 backdrop-blur-sm font-semibold px-8"
              >
                <Link to="/calculadora">
                  <i className="fas fa-calculator mr-2"></i>
                  Calculadora Gratuita
                </Link>
              </Button>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;